module.exports = __webpack_public_path__ + "img/17.c1a37ef3.jpg";